console.log('custom.js LOADED');

document.addEventListener('DOMContentLoaded', function () {
  console.log('custom-byela.js LOADED');

  var accordions = document.querySelectorAll('details.accordion');
  console.log('Found accordions:', accordions.length);

  accordions.forEach(function (details) {
    function updateState() {
      var isOpen = details.hasAttribute('open');
      console.log('updateState: open =', isOpen);

      if (isOpen) {
        details.classList.add('acc-open');
      } else {
        details.classList.remove('acc-open');
      }
    }

    // Native <details> toggle event works in Safari/iOS
    details.addEventListener('toggle', updateState);

    // Safety: also watch summary clicks in case theme JS is involved
    var summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function () {
        setTimeout(updateState, 0);
      });
    }

    // Initial state
    updateState();
  });
});


